import { Box } from "@mui-wrapper";
import {
  UlmInputLabel,
  UlmInputLabelProps,
} from "@components/ulm/ulm-input-label";
import {
  UlmTextField,
  UlmTextFieldProps,
} from "@components/ulm/ulm-text-field";

/** Single text input to complete the account information */
export function CompleteAccountInput({
  title,
  value,
  type,
  name,
  autoComplete,
  isValidValue,
  isError,
  errorText,
  placeholder,
  onChange,
  isDisabled,
}: UlmInputLabelProps & UlmTextFieldProps): JSX.Element | undefined {
  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <UlmInputLabel title={title} isDisabled={isDisabled} />
      <UlmTextField
        value={value}
        type={type}
        name={name}
        autoComplete={autoComplete}
        isValidValue={isValidValue}
        isError={isError}
        errorText={errorText ?? "At least one character required"}
        placeholder={placeholder}
        onChange={onChange}
        isDisabled={isDisabled}
      />
    </Box>
  );
}
